import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios/axiosInstance";

export const get_all_users = createAsyncThunk(
  "get/users",
  async (query, { rejectWithValue }) => {
    try {
      // const { data } = await axiosInstance.get(`/auth/getAllUsers`, {
        const { data } = await axiosInstance.get(`/admin/users`, {
        headers: {
          "Content-Type": "application/json",
        },
        params: query,
      });

      return data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || error.message
      );
    }
  }
);

export const update_user = createAsyncThunk(
  "user/update",
  async ({ uuid, payload }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.patch(
        `/admin/users/${uuid}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Update failed" }
      );
    }
  }
);
